import CantileverButton from 'components/CantileverButton'
import { StyledCloseIcon } from 'features/assetDatabase/utils/sharedStyles'
import React from 'react'
import styled from 'styled-components'

interface FullImagePreviewerProps {
  imageUrl: string
  onClose: () => void
}

const FullImageModal = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

const FullSizedImage = styled.img`
  max-width: 100%;
  max-height: 100%;
`

export const CloseModalContainer = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
`

export const FullImagePreviewer: React.FC<FullImagePreviewerProps> = ({
  imageUrl,
  onClose,
}) => {
  return (
    <FullImageModal onClick={onClose}>
      <FullSizedImage
        src={imageUrl}
        alt='Full Size'
        onClick={(e) => e.stopPropagation()} // Prevents closing when clicking on the image
      />
      <CloseModalContainer>
        <CantileverButton iconOnly onClick={onClose}>
          <StyledCloseIcon />
        </CantileverButton>
      </CloseModalContainer>
    </FullImageModal>
  )
}
